import React, { useEffect, useRef, useState } from "react";

const ReadMoreText = ({ text }: { text: string }) => {
  const textRef = useRef<HTMLDivElement>(null);
  const [expanded, setExpanded] = useState(false);
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    if (textRef.current) {
      const lineHeight = parseFloat(
        window.getComputedStyle(textRef.current).lineHeight
      );
      const height = textRef.current.scrollHeight;

      const maxHeight = lineHeight * 3; // 5 lines

      if (height > maxHeight) {
        setShowButton(true);
      }
    }
  }, [text]);

  return (
    <div>
      <div
        ref={textRef}
        className="fw-normal fs-14 text-grey89 mb-2"
        style={{
          maxHeight: expanded ? "none" : "calc(1.4em * 3 + 5px)",
          overflow: "hidden",
        }}
      >
        {text}
      </div>

      {showButton && (
        <span
          className="fs-14 fw-normal text-primary font-primary text-decoration-underline btn-press-effect"
          style={{ cursor: "pointer" }}
          onClick={() => setExpanded((p) => !p)}
        >
          {expanded ? "Read less" : "Read more"}
        </span>
      )}
    </div>
  );
};

export default React.memo(ReadMoreText);
